import React, {useState, useEffect} from 'react';
import {Link} from "react-router-dom";
import Style from './Patients.module.scss';
import {$t} from "../../helpers/translator";
import api from "../../helpers/api";
import DataTable from "../miscellaneous/DataTable/DataTable";
import Tooltip from "../miscellaneous/Tooltip/Tooltip";
import DeletePatient from "../clinic/DeletePatient/DeletePatient";
import PatientCreateEdit from "../clinic/PatientCreateEdit/PatientCreateEdit";
import Modal from "../miscellaneous/Modal/Modal";
import moment from 'moment';
import _ from 'lodash';
import {FaEdit} from 'react-icons/fa';
import Input from "../miscellaneous/Input/Input";
import HasPermission from 'helpers/permissions/HasPermission';

function PatientsTable({userType}) {
    const [tableLoading, setTableLoading] = useState(true);
    const [payload, setPayload] = useState({
        sort: 'joined_at',
        order: 'desc',
        search: '',
        page: 1,
        per_page: 15,
        mode: "all"
    });
    const [pagination, setPagination] = useState(null);
    const [patients, setPatients] = useState([]);
    const [addPatientModalShow, setAddPatientModalShow] = useState(false);
    const [editPatientModalShow, setEditPatientModalShow] = useState(false);
    const [patientToEdit, setPatientToEdit] = useState(null);
    const [modalKey, setModalKey] = useState(0);


    useEffect(() => {
        loadPatients();
    }, [payload]);

    const getAPIUrl = () => {
        return `/patient?${_.map(payload, (value, key) => `${key}=${value}`).join('&')}`
    }

    const loadPatients = async () => {
        setTableLoading(true);
        try {
            const res = await api.get(getAPIUrl());
            setPatients(formatRows(res.data.data.data));
            setPagination(res.data.data.pagination);
            setTableLoading(false);
        } catch (e) {
            console.error(e)
        }
    }

    const tablesActionHandler = (data) => {
        if (!data || !data.key) {
            return;
        }

        switch (data.key) {
            case 'cell-main':
                switch (data.value.header) {
                    case 'patient_name':
                        break;
                }
                break;
            case 'delete':
                break;
            case 'page':
                changePage(data.value)
                break;
            case 'header':
                let currentSort = {
                    id: payload.sort,
                    order: payload.order,
                };

                if (!currentSort || currentSort.id && currentSort.id !== data.value) {
                    changeSort(data.value, 'asc');
                } else {
                    changeSort(data.value, currentSort.order === 'asc' ? 'desc' : 'asc');
                }

                break;
            default:
                break;
        }
    }

    const changePage = (page) => {
        const newPayload = {...payload};
        newPayload.page = page;
        setPayload(newPayload);
    }

    const changeSort = (sort, order) => {
        const newPayload = {...payload};
        newPayload.sort = sort;
        newPayload.order = order;
        setPayload(newPayload);
    }

    const formatRows = (rows) => {
        return rows.map(row => {
            row.original_patient_id = row.patient_id;
            row.patient_id = <Link to={`/patient/${row.id}`}>{row.patient_id ? row.patient_id : 'N/A'}</Link>;
            row.patient_name = row.patient_name ? row.patient_name : 'N/A';
            row.clinic_name = <Link to={`/clinic/${row.clinic_id}`}>{row.clinic_name}</Link>;
            row.staff_name = <Link
                to={`/staff/${row.staff_id > 0 ? row.staff_id : -1}`}>{row.staff_name ? row.staff_name : 'N/A'}</Link>;
            row.last_treatment = row.last_treatment ? moment(row.last_treatment).format('ll') : 'N/A';
            //row.last_treatment = <Timestamp time={row.last_treatment}/>
            row.area_name = row.area_name ? row.area_name : 'N/A';
            // row.joined_at = row.joined_at ? moment(row.joined_at).format('ll') : 'N/A';
            row.joined_at = row.joined_at ? moment(row.joined_at).format('ll') : 'N/A';
            row.actionsComponent = <div className="d-flex justify-content-center" style={{gap: '7px'}}>
                <HasPermission permission="patient.edit">
                    <Tooltip content={$t('global.patients.editPatientData')}>
                        <FaEdit onClick={(e) => {
                            editPatient(row)
                        }}/>
                    </Tooltip>
                </HasPermission>
                <HasPermission permission="patient.delete">
                    <Tooltip content={$t('global.patients.deletePatient')}>
                        <DeletePatient id={row.id}
                                       patientName={row.patient_name}
                                       patientId={row.original_patient_id}
                                       style={{fontSize: '20px'}}
                                       onSuccess={loadPatients.bind(this)}
                        />
                    </Tooltip>
                </HasPermission>
            </div>;

            return row;
        });
    }

    const changeMode = (mode) => {
        if (mode !== payload.mode) {
            const newPayload = {...payload};
            newPayload.mode = mode;
            newPayload.page = 1;
            setPayload(newPayload);
        }
    }

    const closeModals = () => {
        // console.log(patients)
        setPatientToEdit(null);
        setAddPatientModalShow(false);
        setEditPatientModalShow(false);
    }

    const onModalSuccess = () => {
        closeModals();
        loadPatients();
    }

    const renderCreateEditPatientModal = () => {
        return (
            <Modal content={<PatientCreateEdit mode={editPatientModalShow ? 'edit' : 'create'}
                                               userType={userType}
                                               patientData={patientToEdit}
                                               onSuccess={onModalSuccess.bind(this)}
                                               key={modalKey}
            />}
                   onClose={(e) => {
                       closeModals()
                   }}
                   visible={addPatientModalShow || editPatientModalShow}/>
        );
    }

    const searchHandler = (e) => {
        const newPayload = {...payload};
        newPayload.search = e.target.value;
        newPayload.page = 1;
        setPayload(newPayload);
    }

    const editPatient = (patient) => {
        let tempPatientEditObj = {...patient}
        setModalKey(modalKey + 1)
        tempPatientEditObj.patient_id = patient.original_patient_id;
        setPatientToEdit(tempPatientEditObj);
        // console.log('>> new pat to edit selected:', tempPatientEditObj)
        setEditPatientModalShow(true);
    }

    const addPatient = () => {
        setModalKey(modalKey + 1)
        setPatientToEdit(null);
        setAddPatientModalShow(true);
    }

    const tableHeaders = [
        {
            name: $t('global.patients.patientId'),
            id: 'patient_id',
            clickable: true
        },
        {
            name: $t('global.patients.patientName'),
            id: 'patient_name',
            clickable: false
        },
        userType === 3 && {
            name: 'Clinic Name',
            id: 'clinic_name',
            clickable: true
        },
        {
            name: 'Last Treatment',
            id: 'last_treatment',
            clickable: true
        },
        {
            name: 'Area',
            id: 'area_name',
            clickable: true
        },
        {
            name: 'Staff Name',
            id: 'staff_name',
            clickable: true
        },
        {
            name: $t('global.patients.gender'),
            id: 'patient_gender',
            clickable: true
        }, {
            name: $t('global.patients.age'),
            id: 'patient_age',
            clickable: true
        },
        {
            name: $t('global.patients.joinedAt'),
            id: 'joined_at',
            clickable: true
        },
        {
            name: '',
            id: 'actionsComponent',
            clickable: false
        }
    ];

    const modes = [
        "all",
        "current",
        "new"
    ];

    return (
        <>
            {renderCreateEditPatientModal()}
            <div className={'container'}>
                <div className={'box'}>
                    <div className={'alma-box'} style={{
                        overflow: 'hidden'
                    }}>
                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            marginTop: '10px',
                            marginBottom: '10px',
                            padding: '0 10px'
                        }}>
                            <div style={{paddingLeft: '15px'}}>
                                <h3 style={{margin: 0}}>{$t(userType === 3 ? 'global.chainDashboard.chainPatients' : 'global.patients.clinicsPatients')}</h3>
                            </div>

                            <HasPermission permission="patient.create">
                                <div className={Style['add-patient-button']}
                                     onClick={() => {
                                         addPatient()
                                     }}>
                                    {$t('global.patients.addPatient')}
                                </div>
                            </HasPermission>
                        </div>

                        <div className={Style['patients-menu']} style={{padding: '0 20px'}}>
                            {modes.map((mode, index) => {
                                const modeText = $t(`global.patients.modes.${mode}`);
                                return (<a key={index}
                                           className={mode === payload.mode ? Style["patients-menu-active-link"] : ""}
                                           href="#" onClick={(e) => {
                                    e.preventDefault();
                                    changeMode(mode)
                                }}>{modeText}</a>)
                            })}
                        </div>

                        <div className={'alma-box-body'} style={{marginTop: '15px'}}>

                            <div className={'alma-fields-row'}>
                                <div className={'alma-field-container'}>
                                    <div
                                        className={'alma-field-header'}>{$t('global.patients.searchPatientByIdOrName')}</div>
                                    <Input name="search"
                                        // style={{maxWidth: '250px'}}
                                           delay={500}
                                           className={`${'alma-input'}`}
                                           type="text"
                                           value={payload.search}
                                           placeholder={"Search.."}
                                           onChange={(e) => searchHandler(e)}/>
                                </div>
                            </div>
                            <DataTable
                                data={patients}
                                headers={tableHeaders}
                                pagination={pagination}
                                loading={tableLoading}
                                apiUrl={getAPIUrl()}
                                sorted={{
                                    id: payload.sort,
                                    desc: payload.order === 'desc'
                                }}
                                onAction={(e) => tablesActionHandler(e)}/>
                        </div>

                    </div>
                </div>
            </div>
        </>
    )
}

export default PatientsTable;
